import { render } from "./WorkflowSettingsBasicDefinition.vue?vue&type=template&id=d6b8d45e&scoped=true"
import script from "./WorkflowSettingsBasicDefinition.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsBasicDefinition.vue?vue&type=script&lang=js"

import "./WorkflowSettingsBasicDefinition.vue?vue&type=style&index=0&id=d6b8d45e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b8d45e"]])

export default __exports__